export default __webpack_public_path__ + "static/media/acuicultura.2283b4e2.jpg";